"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var List = function (props) {
    return (react_1.default.createElement("ul", { className: props.className }, props.children.slice(0, props.children.length).map(function (item, i) { return (react_1.default.createElement(ListItem, { key: i },
        props.icon,
        item)); })));
};
var SList = (0, styled_components_1.default)(List)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var ListItem = styled_components_1.default.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    margin-bottom: 16px;\n\n    svg {\n        margin-right: 10px;\n        flex-shrink: 0;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    margin-bottom: 16px;\n\n    svg {\n        margin-right: 10px;\n        flex-shrink: 0;\n    }\n"])));
exports.default = SList;
var templateObject_1, templateObject_2;
